import { createSelector } from '@ngrx/store';
import { getOneClickState } from '../reducers';

export const getOneClickJobsiteSalesAreaState = createSelector(getOneClickState, state => state.jobsiteSalesAreaState);

export const getOneClickJobsiteSalesAreas = createSelector(
  getOneClickJobsiteSalesAreaState,
  state => state.jobsiteSalesAreaLoaded,
);

export const getOneClickPurchaseOrderRequired = createSelector(
  getOneClickJobsiteSalesAreaState,
  state => state.purchaseOrderRequired,
);
